import { useEffect } from "react";

export const usePreventNoBarScrolling = (selector: string) => {
  useEffect(() => {
    const resetScroll = () => {
      for (const el of document.querySelectorAll(selector)) {
        el.scrollLeft = el.scrollTop = 0;
      }
    };

    window.addEventListener("keydown", resetScroll);
    window.addEventListener("keypress", resetScroll);
    window.addEventListener("keyup", resetScroll);
    window.addEventListener("wheel", resetScroll);
    window.addEventListener("scroll", resetScroll);
    window.addEventListener("mousedown", resetScroll);
    window.addEventListener("mouseup", resetScroll);

    return () => {
      window.removeEventListener("keydown", resetScroll);
      window.removeEventListener("keypress", resetScroll);
      window.removeEventListener("keyup", resetScroll);
      window.removeEventListener("wheel", resetScroll);
      window.removeEventListener("scroll", resetScroll);
      window.removeEventListener("mousedown", resetScroll);
      window.removeEventListener("mouseup", resetScroll);
    };
  }, [selector]);
};
